import { render, staticRenderFns } from "./IsoscelesTrapezoidViz.vue?vue&type=template&id=f44a7fb6&scoped=true"
import script from "./IsoscelesTrapezoidViz.vue?vue&type=script&lang=js"
export * from "./IsoscelesTrapezoidViz.vue?vue&type=script&lang=js"
import style0 from "./IsoscelesTrapezoidViz.vue?vue&type=style&index=0&id=f44a7fb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44a7fb6",
  null
  
)

export default component.exports